import CreateIcon from '@mui/icons-material/CreateNewFolder';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

interface IOptionProps {
  addAllOptionsId?: number | string;
  hasAddAllOptions?: boolean;
  newItemId: number | string;
  option: {
    id: number | string;
    label?: string;
    name?: string;
    number?: string;
  };
  renderProps: {
    'aria-selected'?: boolean;
    key: string;
  };
}

function Option({ addAllOptionsId, hasAddAllOptions, newItemId, option, renderProps }: IOptionProps) {
  const { key, ...restRenderProps } = renderProps;
  if (option.id === newItemId) {
    return (
      <Box component="span" key={key} {...restRenderProps}>
        <Stack direction="row" spacing={2} sx={{ color: 'primary.main' }}>
          <CreateIcon />
          <Box>{option.label || ''}</Box>
        </Stack>
      </Box>
    );
  }
  if (hasAddAllOptions && option.id === addAllOptionsId) {
    return (
      <Box component="span" key={key} {...restRenderProps}>
        <Stack direction="row" spacing={2} sx={{ color: 'primary.main' }}>
          <LibraryAddCheckIcon />
          <Box>{option.label || ''}</Box>
        </Stack>
      </Box>
    );
  }
  return (
    <Box component="span" key={key} {...restRenderProps}>
      <Stack direction="row" spacing={1}>
        <Box component="span" sx={{ color: 'primary.dark', fontWeight: 'bold' }}>
          {option.number || ''}
        </Box>
        <Box
          component="span"
          sx={{
            color: restRenderProps['aria-selected'] ? 'primary.main' : 'text.primary',
          }}
        >
          {option.name || ''}
        </Box>
      </Stack>
    </Box>
  );
}

export default Option;
